export const Kind = 'PREVISIT' as const;

export enum Status {
  Created = 'CREATED',
  MessageSent = 'MESSAGE_SENT',
  MessageUndelivered = 'MESSAGE_UNDELIVERED',
  MessageDelivered = 'MESSAGE_DELIVERED',
  FormStarted = 'FORM_STARTED',
  FormCompleted = 'FORM_COMPLETED',
  FormExpired = 'FORM_EXPIRED',
}
